import { create } from 'zustand';

/**
 * Stan lokalny interfejsu (§16.2: „mały store dla viewportu, filtrów i paneli; dane serwerowe
 * pozostają w React Query"). Ten fundament potrzebuje tylko jednego panelu — arkusza „Więcej"
 * dolnej nawigacji telefonu (§6) — ale plik jest ustrukturyzowany tak, żeby kolejne etapy
 * (filtry drzewa, panel osoby) dokładały własne pola do TEGO SAMEGO store'a, nie tworzyły
 * równoległego stanu obok Zustanda.
 *
 * ŻADNE dane serwerowe (sesja, role, listy zasobów) nie trafiają tutaj — to wyłącznie
 * efemeryczny stan UI, zerowany przy przeładowaniu strony.
 */
export interface UiState {
  isMobileMoreOpen: boolean;
  openMobileMore: () => void;
  closeMobileMore: () => void;
  toggleMobileMore: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  isMobileMoreOpen: false,
  openMobileMore: () => {
    set({ isMobileMoreOpen: true });
  },
  closeMobileMore: () => {
    set({ isMobileMoreOpen: false });
  },
  toggleMobileMore: () => {
    set((state) => ({ isMobileMoreOpen: !state.isMobileMoreOpen }));
  },
}));
